export const commerceBasePath = "commerce/v1";
